import DatePicker from 'react-datepicker';

export default function InputDate({name,onChange,placeholder,value,validationLabel,disabled=false }) {

    const nonValidStyle = {
        backgroundColor: "#dc35454d",
        borderBottom: "1px solid #dc3545"
    }

    const disabledStyle = {
        backgroundColor: "lightgray",
        color: "gray"
    }

    const handleChange = (date) => {

        const e = {
            target:{
                name:"date",
                value:date
            }
        }
        onChange(e);
    }

    return (
        <>
            <DatePicker className="min-h-10 placeholder:text-gray outline-none border-b border-[#504343] bg-[#f5f5f5] px-2 w-full text-md focus:bg-[#ebebeb]" style={disabled ? disabledStyle : (validationLabel ? nonValidStyle : {})} id={name} name={name} dateFormat="dd/MM/yyyy" showIcon selected={value} placeholderText={placeholder} onChange={handleChange} />
            <label htmlFor={name} className="absolute top-0 right-1 text-red text-xs">{validationLabel}</label>
        </>
    )
}